import { Component, Input } from '@angular/core';
import { MESES } from "../../../util/format";
import { Solicitacao } from "../../../model/solicitacao";
import { RespostaUsuarioCns } from "../../../model/usuario-cns";
import { Estabelecimento } from "../../../model/estabelecimento";
import { cnpj, cns, cpf, cep } from "../../../util/format";

@Component({
  selector: 'app-termo-bnafar',
  templateUrl: './termo-bnafar.component.html',
})
export class TermoBnafarComponent {

  @Input() solicitacao: Solicitacao = new Solicitacao();
  @Input() responsavel: RespostaUsuarioCns = new RespostaUsuarioCns();
  @Input() estabelecimento: Estabelecimento = new Estabelecimento();

  dia: string;
  mes: string;
  ano: string;
  hoje: string;
  nomeRepresentanteCessionario: string;
  cpfRepresentanteCessionario: string;
  telefoneRepresentanteCessionario: string;
  emailRepresentanteCessionario: string;
  nomeCessionario: string;
  cnpjCessionario: string;
  enderecoCessionario: string;
  cepCessionario: string;
  cnpj = cnpj;
  cns = cns;
  cpf = cpf;
  cep = cep;

  constructor() {
    const date = new Date();
    this.dia = date.getDate().toString();
    this.mes = MESES[ date.getMonth() ];
    this.ano = date.getFullYear().toString();
    this.hoje = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: 'long', day: '2-digit' }).format(date);
  }

  ngAfterViewInit() {
    this.nomeRepresentanteCessionario = this.responsavel.usuarioSUS.nome;
    this.cpfRepresentanteCessionario = this.responsavel.usuarioSUS.numeroCPF;
    this.telefoneRepresentanteCessionario = this.responsavel.usuarioSUS.numTelefone.toString();
    this.emailRepresentanteCessionario = this.responsavel.usuarioSUS.email;
    this.nomeCessionario = this.estabelecimento.nomeEmpresarial;
    this.cnpjCessionario = this.estabelecimento.numeroCNPJ;
    this.enderecoCessionario = this.estabelecimento.descricaoEndereco;
    this.cepCessionario = this.estabelecimento.cep;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/termo/bnafar/termo-bnafar.component.ts